import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    //所有图片
    allImgList: {
      category: [
        {
          title: "摄影师推荐照片",
          mainColor: "#FF7800",
          icon: "camera",
          id: '1'
        },
        {
          title: "其他照片",
          mainColor: "#FAC638",
          icon: "outline",
          id: '2'
        }
      ],
      list: [
        {
          link: "img/VCG41N698828082.jpg",
          ask: "脸修的瘦一点，鼻子小一点",
          selected: true,
          id: '1',
          name: '图片-1',
          category: '1',//分类
          selectedList: [] //所属产品
        },
        {
          link: "img/7717d2892.jpg",
          ask: "脸修的瘦一点，鼻子小一点",
          selected: true,
          id: '2',
          name: '图片-2',
          category: '1',//分类
          selectedList: [] //所属产品
        },
        {
          link: "img/198ede6d65ca4a85847d8e8020427f5d.jpg",
          ask: "脸修的瘦一点，鼻子小一点",
          selected: true,
          id: '3',
          name: '图片-3',
          category: '1',//分类
          selectedList: [] //所属产品
        },
        {
          link: "img/453.jpg",
          ask: "脸修的瘦一点，鼻子小一点",
          selected: true,
          id: '4',
          name: '图片-4',
          category: '1',//分类
          selectedList: [] //所属产品
        },
        {
          link: "img/41a4790429614884b8c91eff98b23a54.jpg",
          ask: "脸修的瘦一点，鼻子小一点",
          selected: true,
          id: '5',
          name: '图片-5',
          category: '1',//分类
          selectedList: [] //所属产品
        },
        {
          link: "img/VCG211009162465.jpg",

          ask: "脸修的瘦一点，鼻子小一点",
          selected: true,
          id: '6',
          name: '图片-6',
          category: '1',//分类
          selectedList: [] //所属产品
        },
        {
          link: "img/58f9e17f5973423698e591254d1693e3.jpg",
          ask: "",
          name: '图片-7',
          selected: true,
          id: '7',
          category: '1',//分类
          selectedList: [] //所属产品
        },
        {
          link: "img/VCG41N490312998.jpg",
          ask: "",
          selected: true,
          id: '8',
          name: '图片-8',
          category: '1',//分类
          selectedList: [] //所属产品
        },
        {
          link: "img/476599056.jpg",
          ask: "",
          selected: false,
          id: '71',
          name: '图片-9',
          category: '1',//分类
          selectedList: [] //所属产品
        },
        {
          link: "img/VCG41N1015933544.jpg",
          ask: "",
          selected: false,
          id: '81',
          name: '图片-10',
          category: '1',//分类
          selectedList: [] //所属产品
        },

        {
          link: "img/3WGI0g.jpg",

          ask: "脸修的瘦一点，鼻子小一点",
          selected: false,
          id: '9',
          name: '图片-11',
          category: '2',//分类
          selectedList: [] //所属产品
        },
        {
          link: "img/2dde28c3248a475e8994d0548e908577.jpg",
          ask: "脸修的瘦一点，鼻子小一点",
          selected: true,
          id: '10',
          name: '图片-12',
          category: '2',//分类
          selectedList: [] //所属产品
        },
        {
          link: "img/VCG41N516111182.jpg",
          ask: "脸修的瘦一点，鼻子小一点",
          selected: false,
          id: '11',
          name: '图片-13',
          category: '2',//分类
          selectedList: [] //所属产品
        },
        {
          link: "img/978a91188.jpg",

          ask: "脸修的瘦一点，鼻子小一点",
          selected: true,
          id: '12',
          name: '图片-14',
          category: '2',//分类
          selectedList: [] //所属产品
        },
        {
          link: "img/3WJ0Cn.jpg",
          ask: "脸修的瘦一点，鼻子小一点",
          selected: true,
          id: '13',
          name: '图片-15',
          category: '2',//分类
          selectedList: [] //所属产品
        },
        {
          link: "img/3WGRpt.jpg",
          ask: "脸修的瘦一点，鼻子小一点",
          selected: true,
          id: '14',
          name: '图片-16',
          category: '2',//分类
          selectedList: [] //所属产品
        },
        {
          link: "img/3WGjXT.jpg",
          ask: "",
          selected: true,
          id: '15',
          name: '图片-17',
          category: '2',//分类
          selectedList: [] //所属产品
        },
        {
          link: "img/fesvsdv.jpg",
          ask: "",
          selected: true,
          id: '16',
          name: '图片-18',
          category: '2',//分类
          selectedList: [] //所属产品
        },
        {
          link: "img/234.jpg",
          ask: "",
          selected: false,
          id: '17',
          name: '图片-19',
          category: '2',//分类
          selectedList: [] //所属产品
        },
        {
          link: "img/VCG41N956879010.jpg",
          ask: "",
          name: '图片-20',
          selected: true,
          id: '18',
          category: '2',//分类
          selectedList: [] //所属产品
        }
      ]
    },
    //产品的图片
    seletedImgList: [
      {
        name: "韩式精品",
        category: "相册",
        limit: 10,
        count: 1,
        Pcount: 10,
        remark: "脸瘦一点、.鼻子高一点、眼睛大一点",
        bgColor: 'rgba(46,161,247,0.8)',
        id: '1',
        list: []
      },
      {
        name: "韩式精品",
        category: "相框",
        count: 1,
        limit: 1,
        remark: "脸瘦一点、.鼻子高一点、眼睛大一点",
        Pcount: "4",
        bgColor: 'rgba(46,161,247,0.8)',
        id: '2',
        list: []
      },
      {
        name: "韩式精品",
        category: "饰件",
        count: 1,
        limit: 2,
        remark: "脸瘦一点、.鼻子高一点、眼睛大一点",
        Pcount: 1,
        bgColor: 'rgba(46,161,247,0.8)',
        id: '3',
        list: []
      },
      {
        name: "韩式精品",
        category: "桌摆",
        count: 1,
        limit: 4,
        remark: "脸瘦一点、.鼻子高一点、眼睛大一点",
        Pcount: 1,
        bgColor: 'rgba(46,161,247,0.8)',
        id: '4',
        list: []
      },
      {
        name: "韩式精品",
        category: "桌摆",
        count: 1,
        limit: 4,
        remark: "脸瘦一点、.鼻子高一点、眼睛大一点",
        Pcount: 1,
        bgColor: 'rgba(46,161,247,0.8)',
        id: '5',
        list: []
      },
      {
        name: "韩式精品",
        category: "桌摆",
        count: 1,
        limit: 4,
        remark: "脸瘦一点、.鼻子高一点、眼睛大一点",
        Pcount: 1,
        bgColor: 'rgba(46,161,247,0.8)',
        id: '46',
        list: []
      }
    ],
    // 邀请码
    inviteCode: null,
    // 能否操作 true 能 false 不能 
    canRevise: true
  },
  mutations: {
    setCanRevise(state, data) {
      state.canRevise = data
    },
    // 设置所有图片
    setAllImgList(state, data) {
      state.allImgList = data
    },
    // 设置已经选择的图片
    setSeletedImgList(state, data) {
      state.seletedImgList = data
    },
    // 设置邀请码
    setInviteCode(state, key) {
      state.inviteCode = key
      // uni.setStorageSync('inviteCode', key)
    },
    // 图片选中
    selecteImg(state, data) {
      if (!data) return;
      for (let index = 0; index < state.allImgList.list.length; index++) {
        const element = state.allImgList.list[index];
        if (element.id == data.id) {
          if (element.selectedList.length != 0 && !data.data) {
            // 判断照片是否选入相册
            for (let i = 0; i < state.seletedImgList.length; i++) {
              const item = state.seletedImgList[i];
              if (element.selectedList.includes(item.id)) {
                element.selected = false
                setTimeout(()=>{
                  element.selected = true
                })
                // 删除失败
                Vue.prototype.$my_message.show({
                  type: "err",
                  title: "无法删除",
                  data: `<div class='text-18'>此照片已被添加到 <span class='text-orange'>${item.category + '-' + item.name}</span></div>
                  <div class='text-18'> 无法删除</div>`,
                  btns: ["我知道了"],
                  close: function (data) {
                    console.log("我知道了");
                    element.selected = true
                    // console.log(el)
                  },
                });

                return false
              }

            }
          }
          element.selected = data.data
          return
        }
      }
    },
    // 设置需求
    setImgAsk(state, data) {
      for (let index = 0; index < state.allImgList.list.length; index++) {
        const element = state.allImgList.list[index];
        if (element.id == data.id) {
          element.ask = data.data
          break
        }
      }

      outer: for (let i = 0; i < state.seletedImgList.length; i++) {
        const item = state.seletedImgList[i]
        for (let index = 0; index < item.list.length; index++) {
          const element = item.list[index];
          if (element.id == data.id) {
            element.ask = data.data
            break outer
          }

        }
      }

    },
    // 拖入选择
    addSelectImg(state, data) {
      var selecteId = state.seletedImgList[data.selectIndex].id
      for (let index = 0; index < state.allImgList.list.length; index++) {
        const element = state.allImgList.list[index];
        if (element.id == data.id) {
          if (element.selectedList.indexOf(selecteId) == -1) {
            element.selectedList.push(selecteId)
            element.selected ? '' : element.selected = true
            state.seletedImgList[data.selectIndex].list.push(element)
          }
          return
        }
      }

      state.seletedImgList[data.navId].idList.push(data.data)
    },
    //移除拖入
    removeSelectImg(state, data) {
      // 删除已选择列表中的照片
      for (let i = 0; i < state.seletedImgList[data.navId].list.length; i++) {
        if (state.seletedImgList[data.navId].list[i].id == data.id) {
          state.seletedImgList[data.navId].list.splice(i, 1)
          break
        }
      }
      // 删除照片中的标识
      for (let i = 0; i < state.allImgList.list.length; i++) {
        const element = state.allImgList.list[i];
        if (element.id == data.id) {
          let d = element.selectedList.indexOf(state.seletedImgList[data.navId].id)
          if (d > -1) {
            element.selectedList.splice(d, 1)
          }
          break
        }

      }
    }
  },
  getters: {
    getCanRevise: state => {
      return state.canRevise
    },
    // 获取所有图片
    getAllImgList: state => {
      return state.allImgList
    },
    // 获取已选择图片
    getSeletedImgList: state => {
      var allimg = [];
      var getSeletedImgList = state.seletedImgList;

      for (let index = 0; index < state.allImgList.length; index++) {
        const item = state.allImgList[index];
        allimg = allimg.concat(item.list);
      }

      for (let index = 0; index < allimg.length; index++) {
        const item = allimg[index];
        for (let i = 0; i < getSeletedImgList.length; i++) {
          const ite = getSeletedImgList[i];
          if (index == 0) ite.list = [];
          if (ite.idList.indexOf(item.id) > -1) {
            getSeletedImgList[i].list.push(item);
          }
        }
      }

      return getSeletedImgList;
    },
    // 获取邀请码
    getInviteCode: state => {
      return state.inviteCode
    }
  },
  actions: {
  },
  modules: {
  }
})
